import { formatNumber } from '@angular/common';
import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { Language } from '../../../model/enums/language';
import { LanguageService } from '../../../services/language.service';

@Pipe({
  name: 'localiseNumberDigitsInfo',
  pure: true,
  standalone: true,
})
@Injectable({ providedIn: 'root' })
export class LocaliseNumberDigitsInfoPipe implements PipeTransform {
  constructor(private _languageService: LanguageService) {}
  transform(value: number, language?: Language, digitsInfo?: string): string {
    if (!language) {
      language = this._languageService.language;
    }

    return formatNumber(value, language, digitsInfo);
  }
}
